import axiosConfig from "./axiosConfig";

// What was actually written into HubSpot. Empty when HubSpot already held every field -
// the write is additive, so "nothing to do" is a success, not a failure.
export interface HubSpotPushContactResponse {
  pushed: string[];
  pushedAt: string;
}

const postHubSpotPushContact = async (
  authToken: string,
  leadId: string,
  body: { role: string; apolloId: string }
): Promise<HubSpotPushContactResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/${leadId}/hubspot/push-contact`,
    body,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postHubSpotPushContact;
